import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { Form } from 'react-final-form';
import moment from 'moment';
import LeftArrowWhiteIcon from '../icons/LeftArrowWhiteIcon.jsx';
import MilestoneCard from './MilestoneEditCard.jsx';
import EditMilestoneForm from './EditMilestonesForm.jsx';
import { deleteMilestone, updateMilestone } from '../../modules/milestones.js';

const mapDispatchToProps = {
  updateMilestone,
  deleteMilestone,
};

const EditMilestonesFormModal = ({
  entities,
  onHide,
  show,
  onSubmitSuccess,
  onDeleteSuccess,
  archived,
  updateMilestone,
  deleteMilestone,
  entityKey,
  canManage,
}) => {
  const [milestones, setMilestones] = useState([]);
  const [editedMilestone, setEditedMilestone] = useState(null);
  const [loading, setLoading] = useState(false);
  const fields = [
    {
      label: 'Milestone title',
      key: 'name',
      isEditor: false,
      editorInstance: null,
    },
    {
      label: 'Date',
      key: 'date_at',
      isEditor: false,
      editorInstance: null,
    },
    {
      label: 'Notes',
      key: 'notes',
      isEditor: false,
      editorInstance: null,
    },
  ];
  const toggleShowEditForm = (milestone) => {
    setEditedMilestone({ ...milestone, date_at: moment(milestone.date_at) });
  };

  const validate = (values) => {
    const errors = {};
    if (!values.name) {
      errors.name = 'Name is required';
    }
    if (!values.date_at) {
      errors.date_at = 'Date is required';
    }
    return errors;
  };

  const onSubmit = async (values) => {
    setLoading(true);
    const isValidMiles = validate(editedMilestone);

    if (Object.keys(isValidMiles).length === 0) {
      updateMilestone(values.id, {
        ...values,
        date_at: moment(values.date_at).format('YYYY-MM-DD'),
      })
        .then(() => {
          onSubmitSuccess().then((res) => {
            const updatedMilestones = res.entities[entityKey][
              res.result
            ].milestones.filter(
              (m) =>
                moment(m.date_at).format('L') ===
                moment(entities[0].date_at).format('L')
            );
            setMilestones(updatedMilestones);

            if (!updatedMilestones.length) {
              onHide();
            }
            setEditedMilestone(null);
            setLoading(false);
          });
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };

  const onUpdate = (value, key) => {
    if (key === 'date_at' && !value) {
      setEditedMilestone((prev) => ({ ...prev, [key]: '' }));
    } else {
      setEditedMilestone((prev) => ({ ...prev, [key]: value }));
    }
  };
  const onDelete = (milestone) => {
    if (
      !window.confirm(
        `Are you sure you want to delete ${milestone.name ? `"${milestone.name}"` : 'this'} milestone?`
      )
    )
      return;
    deleteMilestone(milestone.id).then(() => {
      const updatedMilestones = milestones.filter(
        (mile) => mile.id !== milestone.id
      );
      setMilestones(updatedMilestones);
      setEditedMilestone(null);
      onDeleteSuccess().then(() => {
        setEditedMilestone(null);
        if (!updatedMilestones.length) {
          onHide();
        }
      });
    });
  };

  useEffect(() => {
    setMilestones(entities);
  }, [entities]);

  return (
    <Modal
      onHide={() => {
        onHide();
        setEditedMilestone(null);
      }}
      show={show}
    >
      {editedMilestone ? (
        <Modal.Header closeButton>
          <Modal.Title style={{ fontWeight: 400 }}>
            <div
              style={{
                display: 'flex',
                flex: '1',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  width: '36px',
                  height: '36px',
                  cursor: 'pointer',
                }}
                onClick={() => setEditedMilestone(null)}
              >
                <LeftArrowWhiteIcon />
              </div>
              <h4>Edit Milestone</h4>
            </div>
          </Modal.Title>
        </Modal.Header>
      ) : null}
      <div style={!editedMilestone ? { padding: '40px' } : { padding: '0' }}>
        {editedMilestone ? (
          <Form
            component={EditMilestoneForm}
            validate={validate}
            onUpdate={onUpdate}
            onDelete={onDelete}
            loading={loading}
            fields={fields}
            data={editedMilestone}
            initialValues={editedMilestone}
            onSubmit={onSubmit}
            handleSubmit={onSubmit}
            handleShowEditForm={toggleShowEditForm}
          />
        ) : (
          <div>
            <h4 className="m-b-32">
              {milestones.length > 1 ? 'Milestones' : 'Milestone'}
            </h4>
            {milestones.map((mile) => (
              <MilestoneCard
                mile={mile}
                handleShowEditForm={toggleShowEditForm}
                archived={archived}
                canManage={canManage}
              />
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default connect(null, mapDispatchToProps)(EditMilestonesFormModal);
